import api from "./api";
import { DashboardStats } from "../types";

export const dashboardService = {
  // Get dashboard statistics (admin only)
  getStats: async (): Promise<DashboardStats> => {
    const response = await api.get("/dashboard/stats");
    return response.data.data;
  },

  // Get analytics (admin only)
  getAnalytics: async (params: { groupBy: string }): Promise<any[]> => {
    const response = await api.get("/dashboard/analytics", { params });
    return response.data.data;
  },

  // Export RSVPs to Excel (admin only)
  exportToExcel: async (): Promise<Blob> => {
    const response = await api.get("/dashboard/export/excel", {
      responseType: "blob",
    });
    return response.data;
  },

  // Export RSVPs to CSV (admin only)
  exportToCSV: async (): Promise<Blob> => {
    const response = await api.get("/dashboard/export/csv", {
      responseType: "blob",
    });
    return response.data;
  },
};
